<script lang="ts">
    import type { Vector } from "./Vector";
    import { transition_setRotation } from "./actions/transition";
    import { getPositionInPane } from "./context";
    import type { MachineState } from "./state/machineState";
    import type { Transition } from "./state/transition";
    import { EditMode } from "./state/uiState";

    export let transition: Transition;
    export let machineState: MachineState;
    export let updateMachineState: (newMachineState: MachineState) => void;
    export let color: string;
    export let strokeWidth: string;
    export let error: boolean = false;
    export let marker: string;

    export let onClick = () => {};

    const positionInPane = getPositionInPane();

    $: node = machineState.machine.nodes[transition.fromNodeId];
    $: uiState = machineState.uiState;

    let pathElement;

    let dragStartRotation = 0;
    let dragStartPointerAlpha = 0;

    let isDragging = false;

    let hasBeenDragged = false;
    
    
    function svgCoordinates2LocalCoordinates(posSvg: Vector): Vector {
        return {
            x: posSvg.x - node.posx,
            y: posSvg.y - node.posy,
        }
    }
    
    function localCoordinates2Alpha(posLocal: Vector): number {
        return Math.atan2(posLocal.y, posLocal.x) * 180/Math.PI;
    }

    function handlePointerDown(event: PointerEvent) {
        // console.log('down')
        hasBeenDragged = false;
        if (uiState.editMode === EditMode.NEUTRAL) {
            pathElement.setPointerCapture(event.pointerId);

            isDragging = true;
            dragStartRotation = transition.rotation;

            const pointerPositionSVG = positionInPane(event.clientX, event.clientY);
            const pointerPositionLocal = svgCoordinates2LocalCoordinates(pointerPositionSVG);

            dragStartPointerAlpha = localCoordinates2Alpha(pointerPositionLocal);

            event.preventDefault();
            event.stopImmediatePropagation();
        } else if (uiState.editMode === EditMode.DELETE) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }

    function handlePointerMove(event: PointerEvent) {
        // console.log('handlePointerMove()');
        if (uiState.editMode === EditMode.NEUTRAL && isDragging) {
            hasBeenDragged = true;

            const pointerPositionSVG = positionInPane(event.clientX, event.clientY);
            const pointerPositionLocal = svgCoordinates2LocalCoordinates(pointerPositionSVG);
            const pointerAlphaNow = localCoordinates2Alpha(pointerPositionLocal);

            const deltaAlpha = pointerAlphaNow - dragStartPointerAlpha;

            const newRotation = (dragStartRotation + deltaAlpha);

            const newMachineState = transition_setRotation(machineState, transition.id, newRotation);
            updateMachineState(newMachineState);
        }
    }

    function handlePointerUp(event: PointerEvent) {
        // console.log('machineState - pointerUp');
        if (!hasBeenDragged) {
            // console.log('machineState - pointerUp - das war ein Click!');
            onClick();
        }
        isDragging = false;
        hasBeenDragged = false;
    }

    function handleClick(event: MouseEvent) {
        event.stopPropagation();
    }

    // Der folgende Code hat mal funktioniert für runde Nodes
    // $: textPosition = {
    //     x: node.posx + Math.cos((rotation + 45) * Math.PI / 180) * 50,
    //     y: node.posy + Math.sin((rotation + 45) * Math.PI / 180) * 50,
    // }

    // Position des Ankers am Text berechnen
    // $: anchorPosition = (() => {
    //     let ap = Math.round((-(transition.rotation + 45 ) + 360) / 45) % 8;
    //     // console.log('Winkel ', transition.rotation + 45)
    //     // console.log('Ankerposition ', ap)
    //     return ap;
    // })();
    $: anchorPosition = (() => {
        if (node.type === 'NodeRect') {
            if (rotation === 0) {
                return 0
            } else if (rotation === 90) {
                return 6
            } else if (rotation === 180) {
                return 4
            } else {
                // rotation === 270
                return 2
            }
        } else {
            return Math.round((-(transition.rotation) + 360) / 45) % 8;
        }
    })()

    $: rotation = node.type === 'NodeCircle' ? transition.rotation : (Math.floor(transition.rotation / 90) * 90 + 360) % 360;
    $: translation = (() => {
        if (node.type === 'NodeRect') {
            if (rotation === 0 || rotation === 180) {
                // const t = (node.width / 2)
                // console.log('translation1', t)
                return node.width / 2;
                // return '20 0'
            } else {
                // return {x: 0, y: node.height / 2}
                // return (node.height / 2).toString() + ' 0';
                return node.height / 2;
            }
        } else {
            return 0;
        }
        // node.type === 'NodeCircle' && rotation === 0 || rotation === 180 ? {x: node.width / 2, y: 0} : {x: 0, y: node.height / 2};
    })();

    // $: console.log('translation', translation)

    $: textPosition = (() => {
        if (node.type === 'NodeRect') {
            if (rotation === 0) {
                return {
                    x: node.posx + node.width/2 + 40,
                    y: node.posy,
                }
            } else if (rotation === 90) {
                return {
                    x: node.posx,
                    y: node.posy + node.height/2 + 40,
                }
            } else if (rotation === 180) {
                return {
                    x: node.posx - node.width/2 - 40,
                    y: node.posy,
                }
            } else {
                // rotation === 270
                return {
                    x: node.posx,
                    y: node.posy - node.height/2 - 40,
                }
            }
        } else {
            return {
                x: node.posx + Math.cos((rotation) * Math.PI / 180) * 50,
                y: node.posy + Math.sin((rotation) * Math.PI / 180) * 50,
            }
        }
    })()
</script>

{#if node.type === 'NodeRect'}
    <g transform="translate({node.posx} {node.posy}) rotate({rotation})">
        <!-- Pfad, der angezeigt wird  -->
        <!-- <path
            d="M20 0 C60 20 20 60 0 20"
            stroke={color}
            stroke-width="1"
            fill="none"
            marker-end="url(#markerArrow)"
        /> -->
        <!-- transform="translate({node.width / 2} 0)" -->
        <path
            transform="translate({translation} 0)"
            d="M 0,-10 C 15,-15 30,-10 30,0 30,10 15,15 0,10"
            stroke={color}
            stroke-width={strokeWidth}
            fill="none"
            marker-end={marker}
        />
        

        <!-- Kontaktfläche -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        {#if uiState.editMode !== EditMode.EXECUTION}
            <path 
                transform="translate({translation} 0)"
                class:contactArea={!error}
                class:contactAreaError={error}
                bind:this={pathElement}
                on:pointerdown={handlePointerDown}
                on:pointermove={handlePointerMove}
                on:pointerup={handlePointerUp}
                on:click={handleClick}
                d="M 0,-10 C 15,-15 30,-10 30,0 30,10 15,15 0,10"
                stroke-width="15"
                fill="none"
            />
        {/if}
        
        <!-- Text
        <g transform = "translate(30 30) rotate({-transition.rotation})">
            <slot anchorPosition={anchorPosition}/>
        </g> -->
    </g>

    <!-- Text -->
    <g transform = "translate({textPosition.x} {textPosition.y})"> 
        <slot anchorPosition={anchorPosition} />
    </g>

    <!-- Debug: Position des Textankers als roten Punkt darstellen  -->
    <!-- <circle cx={textPosition.x} cy={textPosition.y} r="2" fill="red" /> -->
{/if}

<style>
    .contactArea {
        stroke-opacity: 0;
        stroke: black;
    }

    .contactArea:hover {
        stroke-opacity: 0.2;
    }

    .contactAreaError {
        stroke-opacity: 0.2;
        stroke: red;
    }
    
    .contactAreaError:hover {
        stroke-opacity: 0.4;
    }
</style>